import { ProductionJobState } from "./production-job-state.model";
import { ReviewSetState } from "./review-set-state-model";
import { UploadBatchState } from "./upload-batch-state.model";

export class CaseAnalyticsState {
	caseId: string;
    userFirstName: string;
    uploadBatchState: UploadBatchState;
    reviewSetState: ReviewSetState;
	productionJobState: ProductionJobState;
}

